export const registerUserRequest = "REGISTER_USER_REQUEST";
export const registerUserSuccess = "REGISTER_USER_SUCCESS";
export const registerUserFail = "REGISTER_USER_FAIL";
